<template lang="html">
  <section class="section is-steel is-bold">
    <h2 class="title is-size-2 has-text-centered">Features</h2>
    <ul class="ul features-list">
      <li class="feature">
        <img
          src="https://red.callcw.com/assets/img/content/scanBoxes.svg"
          class="icon"
        />
        <div class="details is-readable-width">
          <h3 class="title font-light is-size-3">Scan Boxes</h3>
          <p class="is-size-4 has-text-grey-light">
            No-hassle access to info about your rolloffs. Simply hold your phone
            up to the NFC chip mounted on the box. All the box specs and pending
            service details are retrieved, and ordering new service is one tap
            away!
          </p>
        </div>
      </li>
      <li class="feature">
        <img
          src="https://red.callcw.com/assets/img/content/submitOrders.svg"
          class="icon"
        />
        <div class="details is-readable-width">
          <h3 class="title font-light is-size-3">Submit Orders</h3>
          <p class="is-size-4 has-text-grey-light">
            Request a set, pull, respot, or roundtrip through a simple
            interface. Choose size and intended use for the box, add special
            instructions, and specify a preferred date for your box to be
            serviced. No phone call necessary.
          </p>
        </div>
      </li>
      <li class="feature">
        <img
          src="https://red.callcw.com/assets/img/content/viewProjects.svg"
          class="icon"
        />
        <div class="details is-readable-width">
          <h3 class="title font-light is-size-3">View Projects</h3>
          <p class="is-size-4 has-text-grey-light">
            Get a bird's-eye view of all your projects and know where your boxes
            are. Streamline your job.
          </p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'cw-features',
};
</script>

<style lang="stylus" scoped>
.features-list {
  display: flex
  flex-direction: column
  align-items: center
  .feature {
    display: inline-flex
    text-align: left
    align-items: center
    .icon {
      width: 30vw
      height: @width
      border-radius: 9999px
    }
  }


}

@media (max-width:700px) {

  .features-list{
  .feature {
    margin-top: 2em
    flex-direction: column
    text-align: center
    .icon {
      margin: 1em
      width: 50vw
      height: @width
    }
  }
  }
}
</style>
